import { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { RazorNumberFormat } from "../../../../components/razor-reuse";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import { getArrayOfValues } from "../../../../utils/Helper";

// Register required components for a bar chart
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false, // No chart title
    },
    legend: {
      //   display: false, // Hide legend
      position: "bottom",
    },

    datalabels: {
      display: false,
    },
  },
  scales: {
    x: {
      grid: {
        display: false, // Remove X-axis grid lines
      },
    },
    y: {
      beginAtZero: true, // Y-axis starts from 0
      grid: {
        display: false,
      },
      ticks: {
        callback: (val: number) =>
          RazorNumberFormat(val, {
            hideDecimal: true,
            hideSymbol: true,
            numberAbbreviate: true,
          }), // Format tick values dynamically
        display: true,
      },
    },
  },
};

interface MyComponentProps {
  datatoShow?: any;
  activeTab?: string;
}

const CurrencyExchangeBarChart = ({ activeTab }: MyComponentProps) => {
  const [datatoSHow, setDataToShow] = useState<any>({
    labels: [],
    datasets: [
      {
        label: "NGN - CAD",
        data: [],
        backgroundColor: "#6662F4",
        borderColor: "#6662F4",
        borderWidth: 1,
      },
      {
        label: "CAD - NGN",
        data: [],
        backgroundColor: "#E76E50",
        borderColor: "#E76E50",
        borderWidth: 1,
      },
    ],
  });

  const { currency_exchange_metric } = useSelector(
    (state: RootState) => state.dashboard
  );

  useEffect(() => {
    if (Object?.keys(currency_exchange_metric)?.length > 0) {
      const val = {
        labels: getArrayOfValues(
          "label",
          currency_exchange_metric,
          false,
          activeTab !== "year"
        ),
        datasets: [
          {
            label: "NGN - CAD",
            data: getArrayOfValues(
              "ngn_to_cad",
              currency_exchange_metric,
              true
            ),
            backgroundColor: "#6662F4",
            borderColor: "#6662F4",
            // borderWidth: 1,
          },
          {
            label: "CAD - NGN",
            data: getArrayOfValues(
              "cad_to_ngn",
              currency_exchange_metric,
              true
            ),
            backgroundColor: "#E76E50",
            borderColor: "#E76E50",
            // borderWidth: 1,
          },
        ],
      };
      setDataToShow(val);
    }
  }, [currency_exchange_metric]);

  return (
    <Bar data={datatoSHow} options={options as any} height={100} width={100} />
  );
};

export default CurrencyExchangeBarChart;
